import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "@webcore/services/api/api.ts";
import coreContextReducer, { userContextListenerMiddleware } from "@webcore/store/slices/userContextSlice.ts";

// The MFE shares the same RTK Query API slice and the same coreContext slice as web-client. It
// establishes a read-only session against its own origin, then loads its CoreApplicationContext into
// coreContext so the shared provider/hook work exactly as they do in web-client (just read scope).
export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    coreContext: coreContextReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, userContextListenerMiddleware.middleware)
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
